import { render, staticRenderFns } from "./commonFinishPaper.vue?vue&type=template&id=2113b44a&scoped=true&"
import script from "./commonFinishPaper.vue?vue&type=script&lang=js&"
export * from "./commonFinishPaper.vue?vue&type=script&lang=js&"
import style0 from "./commonFinishPaper.vue?vue&type=style&index=0&id=2113b44a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113b44a",
  null
  
)

export default component.exports